import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { IMG_EMPTY_MATCHING, IMG_EMPTY_MATCHING_ANIMATED } from 'images';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: 24,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    maxWidth: 300,
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: 1.31,
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: 30,
    textAlign: 'center',
    paddingLeft: 295,
  },
}));

const EmptyResponse = ({ isParsing }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        src={isParsing ? IMG_EMPTY_MATCHING_ANIMATED : IMG_EMPTY_MATCHING}
        alt="Empty talent list"
      />
      <Typography classes={{ root: classes.text }}>
        {isParsing ? 'Parsing Resume' : 'Upload Resume for AI to parse'}
      </Typography>
    </div>
  );
};

export default EmptyResponse;
